import { render, staticRenderFns } from "./MonthlyCharges.vue?vue&type=template&id=4d55469c&"
import script from "./MonthlyCharges.vue?vue&type=script&lang=ts&"
export * from "./MonthlyCharges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports